import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

type InitialState = {
  reviewModal: boolean;
};

const initialState: InitialState = {
  reviewModal: false,
};

const reviewModalSlice = createSlice({
  name: "reviewModalSlice",
  initialState,
  reducers: {
    toggleReviewModal: (state, action: PayloadAction) => {
      state.reviewModal = !state.reviewModal;
      return state;
    },
  },
});

export const { toggleReviewModal } = reviewModalSlice.actions;
export default reviewModalSlice;
